import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../../common/api/queryKeys/queries';

export function useProductsByIds(productIds: string[]) {
    return useQuery(queries.products.byId(productIds));
}
